/* eslint-disable no-unused-vars */
import axios from "axios";
import * as dotenv from 'dotenv'
dotenv.config()

const BASE_URL = (process.env.VUE_APP_AMB === 'dev') ? process.env.VUE_APP_API_DEV : process.env.VUE_APP_API_PROD

const formatarNomeArquivos = (files, tipo) => {
    //
    const filesName = []
    const arquivosRenomeados = []
    files.forEach((file, idx) => {
        const novoNome = `[${tipo}-${idx}] ${file.name}`
        arquivosRenomeados.push(renameFile(file, novoNome))
        filesName.push({
            nome: novoNome,
            type: file.type
        })
    });
    return {
        filesName,
        arquivosRenomeados
    }
}

const renameFile = (originalFile, newName) => {
    return new File([originalFile], newName, {
        type: originalFile.type,
        lastModified: originalFile.lastModified,
    })
}

const enviarArquivos = async (arraySignedPost, arrayFiles) => {
    const allPromisses = []
    arraySignedPost.forEach(
        (resp, index) => {
            const promise = new Promise((resolve, reject) => {
                const formData = new FormData();
                const file = arrayFiles.arquivosRenomeados[index]
                Object.keys(resp.fields).forEach(key => {
                    formData.append(key, resp.fields[key]);
                });
                // Actual file has to be appended last.
                formData.append("file", file);
                formData.append('Content-Type', file.type);
                const xhr = new XMLHttpRequest();
                xhr.open("POST", resp.url, true);
                xhr.send(formData);
                xhr.onload = function (response) {
                    response ? resolve() : reject();
                };
            })
            allPromisses.push(promise)
        })
    return await Promise.all(allPromisses)
}

const API = {
    async enviarForm(dados) {
        try {
            const evidencias = formatarNomeArquivos(dados.files, 'EVIDENCIA')
            const manuais = formatarNomeArquivos(dados.manuais, 'MANUTENCAO')
            dados.files = evidencias.filesName
            dados.manuais = manuais.filesName

            const resultado = await axios
                .post(`${BASE_URL}/tickets`, dados, {})

            await enviarArquivos(resultado.data.postsEvidencias, evidencias)
            await enviarArquivos(resultado.data.postsManuais, manuais)

            return {
                status: 200,
                data: {
                    id_ticket: resultado.data.id_ticket
                }
            }
        } catch (error) {
            console.log('Erro ao enviar forms', error)
            throw {
                error,
                msg: 'Erro ao enviar os arquivos'
            }
        }
    },
    async enviarSatisfacao(dados) {
        try {
            const resultado = await axios
                .post(`${BASE_URL}/satisfacao`, dados, {})
            return {
                status: 200,
                data: resultado
            }
        } catch (error) {
            console.log('Erro ao enviar formsssssSSS', error)
            throw {
                error,
                msg: 'Erro ao enviar os arquivos'
            }
        }
    },
    async buscarSatisfacao(id) {
        try {
            const resultado = await axios
                .get(`${BASE_URL}/satisfacao/${id.replaceAll('#', '/')}`)
            return resultado.data.result || []
        } catch (error) {
            console.log('Erro ao enviar forms', error)
            throw {
                error,
                msg: 'Erro ao buscar satisfação'
            }
        }
    },
    async buscarSatisfacaoByEmail(email) {
        try {
            const resultado = await axios
                .get(`${BASE_URL}/satisfacao/${email}`)
            return resultado.data.result || []
        } catch (error) {
            console.log('Erro ao buscar satisfação por email', error)
            throw {
                error,
                msg: 'Erro ao buscar satisfação por email'
            }
        }
    },

    async buscarTicketPortal(id) {
        try {
            const resultado = await axios
                .get(`${BASE_URL}/tickets/ANDAMENTO_${id}`)
            return resultado.data?.result?.Items[0] || null
        } catch (error) {
            console.log('Erro ao buscar ticket', error)
            throw {
                error,
                msg: 'Ticket não encontrado'
            }
        }
    },
    async acessarPortalTicket(id, senha, token, email, cliente = 'GALI') {
        try {
            const resultado = await axios.post(`${BASE_URL}/tickets/portal-acesso`, {
                ticketId: id,
                senha: senha.toUpperCase(),
                token,
                cliente,
                email
            })
            console.log('Acesso ao portal', resultado.data)
            return resultado.data?.result || null
        } catch (error) {
            const status = error?.response?.status
            console.log('Erro ao acessar portal', error)
            throw {
                error,
                status,
                msg: status === 401 ? 'Senha inválida' : 'Ticket não encontrado'
            }
        }
    },
    async buscarInteracoesTicket(id, cliente = 'GALI') {
        try {
            const resultado = await axios
                .get(`${BASE_URL}/tickets/${id}/interacao?isInterno=false`)
            console.log('Interações do ticket', resultado.data)
            return resultado.data.result || []
        } catch (error) {
            const status = error?.response?.status
            console.log('Erro ao buscar interações do ticket', error)
            throw {
                error,
                status,
                msg: status === 'Erro ao buscar interações do ticket'
            }
        }
    },
    async adicionarInteracaoPortal(ticket, dados, arquivos = []) {
        try {
            const filesMap = arquivos.map(f => ({
                nome: f.name,
                type: f.type,
            }))

            const token = sessionStorage.getItem("token") || 'token-invalido'
            const id = ticket.id.split('_').pop()
            const Emails = [
                ticket.email,
                ticket.emailSecundario
            ];
            if (ticket.emailAcompanhamento && ticket.emailAcompanhamento.length > 0) {
                Emails.push(...ticket.emailAcompanhamento);
            }
            const resp = await axios.post(`${BASE_URL}/tickets/${id}/interacao`, {
                dados,
                id,
                token,
                cliente: 'GALI',
                Emails,
                ehDelete: false,
                filesMap,
            })

            const presignedUrls = resp.data?.presignedUrls || []
            if (presignedUrls.length > 0) {
                await Promise.all(
                    presignedUrls.map((postUrl, index) => new Promise((resolve, reject) => {
                        const formData = new FormData()
                        Object.keys(postUrl.fields).forEach(key => {
                            formData.append(key, postUrl.fields[key])
                        })
                        // O arquivo real deve ser o último campo
                        formData.append('file', arquivos[index])
                        formData.append('Content-Type', arquivos[index].type)

                        const xhr = new XMLHttpRequest()
                        xhr.open('POST', postUrl.url, true)
                        xhr.onload = function (response) {
                            response ? resolve() : reject()
                        }
                        xhr.onerror = reject
                        xhr.send(formData)
                    }))
                )
            }

            return resp.data
        } catch (error) {
            console.log('Erro ao adicionar interação', error)
            throw {
                error,
                msg: 'Erro ao enviar interação'
            }
        }
    },
    async buscarArquivosOcorrencia(id) {
        try {
            const resp = await axios
                .get(`${BASE_URL}/tickets/ANDAMENTO_${id}/files/OCORRENCIA`)
            return resp.data.dados || []
        } catch (error) {
            console.log('Erro ao buscar arquivos', error)
            return []
        }
    },
    async getArquivoSignedUrl(ticketId, fileName) {
        try {
            const resp = await axios.post(`${BASE_URL}/getFile`, {
                fileName,
                ticket: `ANDAMENTO_${ticketId}`
            })
            return resp.data.signUrl
        } catch (error) {
            console.log('Erro ao obter URL assinada', error)
            throw error
        }
    },

    async refreshTokenPortal() {
        try {
            const token = sessionStorage.getItem("token") || 'token-invalido'
            const resp = await axios.post(
                `${BASE_URL}/tickets/refresh-token`,
                { token },
            )
            sessionStorage.setItem("token", resp.data.result.token)
            return resp.data.result.token
        } catch (error) {
            console.log('Erro ao renovar token do portal', error)
            throw error
        }
    },

}

export default API